<ng-container *ngIf="viewModel$ | async as vm">
  <h5>UFields</h5>
  <form *ngIf="fgMaster$ | async as fg" [formGroup]="fg">
    <div class="form-row">
      <div class="col form-group">
        <label for="u1">U1</label>
        <input
          id="u1"
          type="text"
          class="form-control"
          formControlName="u1"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u2">U2</label>
        <input
          id="u2"
          type="datetime-local"
          class="form-control"
          formControlName="u2"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u3">U3</label>
        <input
          id="u3"
          type="text"
          class="form-control"
          formControlName="u3"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u4">U4</label>
        <input
          id="u4"
          type="text"
          class="form-control"
          formControlName="u4"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="u5">U5</label>
        <input
          id="u5"
          type="text"
          class="form-control"
          formControlName="u5"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u6">U6</label>
        <input
          id="u6"
          type="text"
          class="form-control"
          formControlName="u6"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u7">U7</label>
        <input
          id="u7"
          type="text"
          class="form-control"
          formControlName="u7"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u8">U8</label>
        <input
          id="u8"
          type="text"
          class="form-control"
          formControlName="u8"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="u9">U9</label>
        <input
          id="u9"
          type="text"
          class="form-control"
          formControlName="u9"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u10">U10</label>
        <input
          id="u10"
          type="text"
          class="form-control"
          formControlName="u10"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u11">U11</label>
        <input
          id="u11"
          type="text"
          class="form-control"
          formControlName="u11"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u12">U12</label>
        <input
          id="u12"
          type="text"
          class="form-control"
          formControlName="u12"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="u13">U13</label>
        <input
          id="u13"
          type="text"
          class="form-control"
          formControlName="u13"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u14">U14</label>
        <input
          id="u14"
          type="text"
          class="form-control"
          formControlName="u14"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u15">U15</label>
        <input
          id="u15"
          type="text"
          class="form-control"
          formControlName="u15"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u16">U16</label>
        <input
          id="u16"
          type="text"
          class="form-control"
          formControlName="u16"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="u17">U17</label>
        <input
          id="u17"
          type="text"
          class="form-control"
          formControlName="u17"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u18">U18</label>
        <input
          id="u18"
          type="text"
          class="form-control"
          formControlName="u18"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u19">U19</label>
        <input
          id="u19"
          type="text"
          class="form-control"
          formControlName="u19"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
      <div class="col">
        <label for="u20">U20</label>
        <input
          id="u20"
          type="text"
          class="form-control"
          formControlName="u20"
          autocomplete="off"
          aria-autocomplete="list"
        />
      </div>
    </div>
  </form>
  <h5>Answers</h5>
  <form *ngIf="fgQField$ | async as fg" [formGroup]="fg">
    <div class="form-row">
      <div class="col-auto">
        <label for="qField">QField</label>
        <select id="qField" class="form-control" formControlName="qField">
          <option *ngFor="let q of vm.questions" value="{{ q }}">
            {{ q }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label for="answer"></label>
        <ng-container *ngFor="let q of vm.questions">
          <textarea
            *ngIf="q === vm.qField"
            id="answer"
            class="form-control"
            formControlName="{{ q }}"
            rows="4"
            autocomplete="off"
            aria-autocomplete="list"
          ></textarea>
        </ng-container>
      </div>
    </div>
  </form>
  <h5>Master</h5>
  <pre>{{ vm.master | json }}</pre>
  <h5>Action</h5>
  <pre>{{ vm.action | json }}</pre>
  <h5>Answers</h5>
  <pre>{{ vm.answers | json }}</pre>
  <h5>Variables</h5>
  <pre>{{ vm.variables | json }}</pre>
</ng-container>
